<template>
  <el-menu class="navbar" mode="horizontal">
    <div class="grid-wrapper">
      <div class="hearlogo">
        <div class="avatar-container">
          <el-image class="user-avatar" :src="logo_icon" :fit="'contain'">
            <div slot="error" class="image-slot"></div>
          </el-image>
        </div>
        <div class="text-container">
          <span class="main-name">
            <span class="main-name1">{{ empname }}</span
            ><span class="main-name2"></span>
          </span>
        </div>
      </div>

      <span />
      <el-dialog
        :visible.sync="gbDialogVisible"
        title="留言板"
        width="30%"
        :append-to-body="true"
      >
        <GuestBook></GuestBook>
      </el-dialog>
      <div class="nav-right">
        <qr-code />
        <el-button
          type="success"
          @click="gbDialogVisible = true"
          icon="el-icon-edit-outline"
          :circle="true"
          title="留言板"
          style="margin-left: 15px"
        >
        </el-button>
        <MessageList />
        <div class="principal-wrapper">
          <div class="user-info">
            <div class="avatar-wrapper">
              <svg-icon icon-class="user" class="user-avatar"></svg-icon>
            </div>

            <div class="user">
              <div class="phone">{{ phone }}</div>
              <div class="name">{{ name }}</div>
            </div>
          </div>

          <el-dropdown trigger="click">
            <div class="more">
              <i class="more-icon el-icon-caret-bottom"></i>
            </div>
            <el-dropdown-menu class="user-dropdown" slot="dropdown">
              <router-link class="inlineBlock" to="/">
                <el-dropdown-item>首页</el-dropdown-item>
              </router-link>
              <el-dropdown-item divided>
                <span @click="updatePassWord" style="display: block"
                  >修改密码</span
                >
              </el-dropdown-item>
              <el-dropdown-item divided>
                <span @click="logout" style="display: block">退出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <template v-if="showpub">
      <PassWord @cancel="closewindow"> </PassWord
    ></template>
  </el-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import QrCode from "./QrCode.vue";
import GuestBook from "./GuestBook.vue";
import PassWord from "./PassWord.vue";
import MessageList from "./MessageList.vue";
import { setCookie, getCookie } from "@/utils/support";

export default {
  data() {
    return {
      showpub: false,
      logo_icon: window.localStorage.getItem("LOGOURL"),
      empname: window.localStorage.getItem("EMPNAME"),
      gbDialogVisible: false,
    };
  },
  components: {
    Breadcrumb,
    Hamburger,
    QrCode,
    GuestBook,
    PassWord,
    MessageList
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "name", "phone"]),
  },
  methods: {
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    updatePassWord() {
      this.showpub = true;
    },
    closewindow() {
      this.showpub = false;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.navbar {
  height: 80px;
  border-radius: 0px !important;
  display: flex;
  align-items: center;
  .grid-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    background-color: #409eff;
    align-items: center;
    .nav-right {
      margin-left: auto;
      display: flex;
      align-items: center;
    }
  }
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .qrcode-wrapper {
    display: inline-block;
    padding: 0 10px;
    .label {
      float: left;
      line-height: 40px;
      padding-right: 5px;
    }
    .qrcode-svg {
      height: 40px;
      width: 40px;
      vertical-align: 0em;
      cursor: pointer;
    }
  }
  .principal-wrapper {
    display: flex;
    align-items: center;
    padding: 0 10px;
    padding-left: 15px;
    margin-left: 15px;
    border-left: 1px solid rgba(255, 255, 255, 0.3);
    .more {
      display: flex;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .more-icon {
        font-size: 20px;
        color: #fff;
      }
    }
    .label {
      float: left;
      line-height: 70px;
      padding-right: 5px;
      color: #fff;
    }
  }
  .user-info {
    display: flex;
    align-items: center;
  }
  .avatar-wrapper {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.15);
    cursor: pointer;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    .user-avatar {
      width: 30px;
      height: 30px;
    }
    .el-icon-caret-bottom {
      font-size: 22px;
    }
  }
  .user {
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    .phone {
      color: #fff;
      font-size: 16px;
    }
    .name {
      color: rgba(255, 255, 255, 0.7);
      font-size: 12px;
      margin-top: 2px;
    }
  }
}

.hearlogo {
  flex: 1;
  display: flex;
  align-items: center;
}
.avatar-container {
  line-height: 30px;
  display: inline-block;
  vertical-align: middle;
  .user-avatar {
    height: 60px;
    width: 60px;
    vertical-align: middle;
    margin-left: 30px;
    object-fit: cover;
  }
}
.text-container {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.text-container span {
  margin: 0;
  color: #ffffff;
  font-size: 30px;
  line-height: 1;
}

@media (max-width: 1400px) {
  .text-container {
    /* display: none !important; */
  }
  .phone {
    width: 70px !important;
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .name {
    width: 70px !important;
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .avatar-container {
    .user-avatar {
      height: 50px !important;
      width: 50px !important;
    }
  }
  .text-container span {
    font-size: 24px;
  }
}

// @media (max-width: 1000px) {
//   .hearlogo {
//     .main-name {
//       display: flex;
//       flex-direction: column;
//       .main-name2 {
//         font-size: 12px;
//         margin-top: 6px;
//       }
//     }
//   }
// }
// @media (max-width: 880px) {
//   .hearlogo {
//     .main-name {
//       display: none;
//     }
//   }
// }
.main-name {
   max-width: 33vw !important;
   text-align: center;
}
.main-name1 {
   font-size: 1.5vw !important;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue